<div class="taxonomy-dropdown-container">
  <div class="taxonomy-button" [matMenuTriggerFor]="dropdownMenu" (click)="handleButtonClick($event)">
    <img class="taxonomy_icon" src="assets/icons/taxonomy_colored.svg">
    {{selectedValue?.label }}
    <div class="button-icon">
      <img src="assets/icons/keyboard_arrow_down_new.svg">
    </div>
  </div>

  <mat-menu [class]="'width-300px'" #dropdownMenu="matMenu" xPosition="before" yPosition="below"
    (closed)="onMatMenuClosed()">
    <div class="list-header">
      Select item to filter
    </div>

    <div class="list-wrapper">
      <div class="list-item" *ngFor="let item of contentList" (click)="handleItemSelect($event, item)">
        <div class="list-item-wrapper">
          <div class="item-bullet">
            <img *ngIf="item.value !== selectedValue?.value;else selected" class="empty"
              src="assets/icons/radio_empty.svg">
            <ng-template #selected>
              <img class="selected" src="assets/icons/radio_selected.svg">
            </ng-template>
          </div>
          {{item.label}}
        </div>

      </div>
    </div>
  </mat-menu>
</div>